document.addEventListener('DOMContentLoaded', () => {
  /*  0. OFF-SCREEN RENDERING GUARD  -------------------------------------
     theme.js puts data-page-rendering on <body> so theme.css can apply
     content-visibility:auto to every section from the third onward. It is a
     first-paint optimisation, and theme.js only ever removes it on the first
     click / mousemove / keydown / touchstart / touchmove / wheel.

     A desktop mouse fires mousemove within milliseconds, so the attribute is
     gone before anything depends on it. A phone has no mousemove at all: the
     first event is touchstart, which fires at the exact moment the reader
     starts to scroll. Until then every section below the second collapses to
     0px, the document measures ~2,300px instead of ~14,200px, and every
     ScrollTrigger start/end is computed against those wrong numbers. That is
     why the pinned horizontal carousel draws over the sections around it and
     leaves an empty gap below itself on mobile.

     Drop the attribute once the page has loaded, force a layout so the
     sections report their real heights, then let ScrollTrigger re-measure.
     Runs even if theme.js already removed the attribute, because theme.js
     does not refresh ScrollTrigger afterwards. */
  let dhsRenderingFlagCleared = false;
  const dhsClearRenderingFlag = () => {
    if (dhsRenderingFlagCleared) return;
    dhsRenderingFlagCleared = true;
    document.body.removeAttribute('data-page-rendering');
    void document.documentElement.scrollHeight;
    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      window.ScrollTrigger.refresh();
    }
  };
  if (document.readyState === 'complete') {
    dhsClearRenderingFlag();
  } else {
    window.addEventListener('load', dhsClearRenderingFlag, { once: true });
  }
  /* Belt and braces: one stalled third-party asset can hold 'load' open for a
     long time, and the reader will have started scrolling well before then. */
  setTimeout(dhsClearRenderingFlag, 2000);

  /*  0b. FINISH A DERMAL DIAGNOSIS CLAIM THAT STARTED SIGNED OUT  -------
     An assessment is attached to an account by POSTing its token to the
     app proxy from a signed-in session. The result page does that, but a
     reader who arrives from an email has no session, so it stores the
     token instead and offers a sign-in link.

     Shopify's new customer accounts flow does NOT honour return_url, so
     they come back somewhere of Shopify's choosing - My Skin, the account
     page, the home page. Guessing which one is how the first attempt at
     this missed. Living here instead, in a file theme.liquid loads on
     every template, means whichever page they land on finishes the job.

     Costs nothing when there is no pending token, which is almost always. */
  (function () {
    var STASH = 'dd_pending_token';
    var token = '';
    try { token = (localStorage.getItem(STASH) || '').trim().toUpperCase(); }
    catch (e) { return; }
    if (!/^[0-9A-HJKMNP-TV-Z]{12}$/.test(token)) return;
    /* The result page owns the token while they are on it. */
    if (/[?&]k=/.test(window.location.search)) return;

    try {
      fetch('/apps/dd/claim', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          /* Still signed out: keep it and try again next page. */
          if (!j || j.signed_in === false) return;
          try { localStorage.removeItem(STASH); } catch (e) {}
          /* It attached just now, so a list already drawn on this page is
             one short. Only reload where that list actually lives. */
          if (j.claimed > 0 && /my-skin|account/i.test(window.location.pathname)) {
            window.location.reload();
          }
        })
        .catch(function () {});
    } catch (e) {}
  })();

    /*  A. THEME SWITCHER ENGINE */
    const htmlRoot = document.documentElement;
    const themeBtns = document.querySelectorAll('[data-set-theme]');
    themeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetTheme = btn.getAttribute('data-set-theme');
        htmlRoot.setAttribute('data-theme', targetTheme);
        themeBtns.forEach((b) => {
          const isActive = b === btn;
          b.classList.toggle('active', isActive);
          b.setAttribute('aria-pressed', isActive);
        });
      });
    });
    
    /* D. GSAP SCROLL CHOREOGRAPHY & COUNTERS
       Wrapped in try/catch: if ScrollTrigger is missing or registerPlugin throws,
       the old code died here silently and left every .dhs-reveal element at
       opacity 0 with no way back. Now the catch hands control to the failsafe in
       theme.liquid by dropping the .dhs-anim class, so the content is readable. */
    if (typeof gsap !== 'undefined') {
      try {
      gsap.registerPlugin(ScrollTrigger);
      // Standard Hierarchy Reveals
      gsap.utils.toArray('.dhs-reveal').forEach((elem) => {
        gsap.fromTo(
          elem,
          { opacity: 0, y: 28, },
          { opacity: 1, y: 0, duration: 1, ease: 'power3.out',
            scrollTrigger: {
              trigger: elem,
              start: 'top 88%',
            },
          }
        );
      });

      /* Tells the guard in dhs-lib.liquid that the reveals really were created,
         so it leaves .dhs-anim in place. */
      window.__dhsRevealReady = true;

      // Numerical Proof Counters
      //
      // start: 'top bottom' -- fire the moment the element enters the viewport,
      // not at 85% of it. The hero stat row sits almost exactly on the old 85%
      // boundary, so on a typical screen the social proof read "0 / 5" and
      // "0 verified reviews" when a visitor landed, and only counted up if they
      // happened to scroll. Zeroed social proof is worse than none at all.
      //
      // onComplete writes the exact target, so the number always lands on 4.93
      // rather than wherever the easing stopped.
      const paintCounter = (el, value, decimals) => {
        el.textContent = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toLocaleString();
      };
      gsap.utils.toArray('[dhs-data-count]').forEach((counter) => {
        const targetNum = parseFloat(counter.getAttribute('dhs-data-count'));
        const decimals = parseInt(counter.getAttribute('dhs-data-decimals') || 0);
        if (!isFinite(targetNum)) return;
        const obj = { val: 0 };
        gsap.to(obj, {
          val: targetNum,
          duration: 1.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: counter,
            start: 'top bottom',
            once: true,
          },
          onUpdate: () => paintCounter(counter, obj.val, decimals),
          onComplete: () => paintCounter(counter, targetNum, decimals),
        });
      });
      } catch (e) {
        /* Something in the GSAP setup failed. Un-hide everything rather than
           leaving the page blank, and say so once in the console. */
        document.documentElement.classList.remove('dhs-anim');
        console.warn('[DHS] reveal animations disabled:', e && e.message);
      }
    } else {
      /* GSAP never arrived. The failsafe rule in theme.liquid is already doing
         the work because .dhs-anim was never added — this is here so the reason
         is visible to anyone debugging. */
      console.warn('[DHS] GSAP unavailable — reveal animations skipped, content shown unanimated.');
      /* The counters are animated by GSAP, so without it they would sit at 0
         forever and advertise zero reviews. Paint the real figures straight in. */
      document.querySelectorAll('[dhs-data-count]').forEach((counter) => {
        const targetNum = parseFloat(counter.getAttribute('dhs-data-count'));
        const decimals = parseInt(counter.getAttribute('dhs-data-decimals') || 0);
        if (!isFinite(targetNum)) return;
        counter.textContent = decimals > 0 ? targetNum.toFixed(decimals) : Math.round(targetNum).toLocaleString();
      });
    }
  });